import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-779bc5e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "declaration_form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Type of support/partnership", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "A. Partnership Description", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "why" }, [
  /*#__PURE__*/_createTextVNode("Why would you like to partner on this innovation?"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "how" }, [
  /*#__PURE__*/_createTextVNode("How would you like to partner on this innovation?"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "B. Next steps", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "steps" }, [
  /*#__PURE__*/_createTextVNode("Potential next steps"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "C. Intent Declarations and Certifications", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = { class: "text-primary my-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Intent Declarations and Certifications", -1))
const _hoisted_14 = { class: "my-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary" }, "Intent to partner", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Partner intends to bid for the opportunity for the above-mentioned Innovation Reference Number and submit a bid for consideration. ", -1))
const _hoisted_17 = { class: "radio" }
const _hoisted_18 = { class: "field-radiobutton" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "intentYes" }, " Yes", -1))
const _hoisted_20 = { class: "field-radiobutton" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "intentNo" }, " No", -1))
const _hoisted_22 = { class: "my-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary" }, "Conflict of Interest Declaration", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " There are no facts or circumstances that could give rise to, our employees or contractors working for us having an organizational, financial or personal conflict of interest with the innovation or innovator(s) ", -1))
const _hoisted_25 = { class: "radio" }
const _hoisted_26 = { class: "field-radiobutton" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "conflictYes" }, " Yes", -1))
const _hoisted_28 = { class: "field-radiobutton" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "conflictNo" }, " No", -1))
const _hoisted_30 = { class: "my-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary" }, " Conflict of Interest Declarations and Certifications ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Partner has been in a position to influence or shape the design or development of the innovation and may have the effect of distorting competition and affecting the fairness and integrity of the new/current partnership process ", -1))
const _hoisted_33 = { class: "radio" }
const _hoisted_34 = { class: "field-radiobutton" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "conflict2Yes" }, " Yes", -1))
const _hoisted_36 = { class: "field-radiobutton" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "conflict2No" }, " No", -1))
const _hoisted_38 = { class: "my-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary" }, "Confidentiality", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Partner certifies that all its employees/contractors will maintain confidentiality in all matters relating to the above innovation need, and will not make any unauthorized disclosure of any confidential information provided by the ministry or innovator ", -1))
const _hoisted_41 = { class: "radio" }
const _hoisted_42 = { class: "field-radiobutton" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confidentialityYes" }, " Yes", -1))
const _hoisted_44 = { class: "field-radiobutton" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confidentialityNo" }, " No", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, " D. Internal and External resources available to meet the innovation needs ", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "resources" }, [
  /*#__PURE__*/_createTextVNode("Please state all resources available to make a successful partnership for the above innovation "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_49 = { class: "d-flex" }
const _hoisted_50 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_BaseCheckBox = _resolveComponent("BaseCheckBox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TermsAndConditions = _resolveComponent("TermsAndConditions")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      ref: "innovationPartner",
      onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createVNode(_component_Dropdown, {
        id: "type",
        name: "type",
        modelValue: _ctx.form.type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.type) = $event)),
        options: _ctx.partnerType,
        optionLabel: "id",
        optionValue: "name",
        placeholder: "Type of support/partnership",
        class: "w-100 mb-3"
      }, null, 8, ["modelValue", "options"]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", null, [
        _hoisted_5,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.why,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.why) = $event)),
          id: "why",
          name: "why",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.how,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.how) = $event)),
          id: "how",
          name: "how",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", null, [
        _hoisted_9,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.steps,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.steps) = $event)),
          id: "steps",
          name: "steps",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_10,
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("section", _hoisted_14, [
          _createElementVNode("div", null, [
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_RadioButton, {
                  id: "intentYes",
                  name: "intent",
                  value: "Yes",
                  modelValue: _ctx.form.intent,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.intent) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_19
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_RadioButton, {
                  id: "intentNo",
                  name: "intent",
                  value: "No",
                  modelValue: _ctx.form.intent,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.intent) = $event)),
                  class: "ml-3"
                }, null, 8, ["modelValue"]),
                _hoisted_21
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_22, [
          _createElementVNode("div", null, [
            _hoisted_23,
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_RadioButton, {
                  id: "conflictYes",
                  name: "conflict",
                  value: "Yes",
                  modelValue: _ctx.form.conflict,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.conflict) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_27
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_RadioButton, {
                  id: "conflictNo",
                  name: "conflict",
                  value: "No",
                  modelValue: _ctx.form.conflict,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.conflict) = $event)),
                  class: "ml-3"
                }, null, 8, ["modelValue"]),
                _hoisted_29
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_30, [
          _createElementVNode("div", null, [
            _hoisted_31,
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_RadioButton, {
                  id: "conflict2Yes",
                  name: "conflict2",
                  value: "Yes",
                  modelValue: _ctx.form.conflictCert,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.conflictCert) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_35
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_RadioButton, {
                  id: "conflict2No",
                  name: "conflict2",
                  value: "No",
                  modelValue: _ctx.form.conflictCert,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.conflictCert) = $event)),
                  class: "ml-3"
                }, null, 8, ["modelValue"]),
                _hoisted_37
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_38, [
          _createElementVNode("div", null, [
            _hoisted_39,
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_RadioButton, {
                  id: "confidentialityYes",
                  name: "confidentiality",
                  value: "Yes",
                  modelValue: _ctx.form.confidentiality,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.confidentiality) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_43
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_RadioButton, {
                  id: "confidentialityNo",
                  name: "confidentiality",
                  value: "No",
                  modelValue: _ctx.form.confidentiality,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.confidentiality) = $event)),
                  class: "ml-3"
                }, null, 8, ["modelValue"]),
                _hoisted_45
              ])
            ])
          ])
        ])
      ]),
      _hoisted_46,
      _hoisted_47,
      _createElementVNode("div", null, [
        _hoisted_48,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.resources,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.resources) = $event)),
          id: "resources",
          name: "resources",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("p", _hoisted_49, [
        _createVNode(_component_BaseCheckBox, {
          checkbox: _ctx.form.terms,
          "onUpdate:checkbox": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.terms) = $event)),
          inputType: _ctx.termsProp
        }, null, 8, ["checkbox", "inputType"]),
        _createElementVNode("span", {
          class: "text-primary text-decoration-underline",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.termsModal = true))
        }, "Terms and Condition")
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createVNode(_component_Button, {
          onClick: _withModifiers(_ctx.saveForLater, ["prevent"]),
          disabled: _ctx.loading,
          class: _normalizeClass([{ submitting: _ctx.loading }, "p-button-text p-button-raised"])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save For Later")
          ]),
          _: 1
        }, 8, ["onClick", "disabled", "class"]),
        _createVNode(_component_Button, {
          onClick: _withModifiers(_ctx.onSubmit, ["prevent"]),
          disabled: _ctx.loading,
          class: _normalizeClass([{ submitting: _ctx.loading }, "p-button-primary p-button-raised px-lg-5 px-4"]),
          "aria-label": "Submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Submit")
          ]),
          _: 1
        }, 8, ["onClick", "disabled", "class"])
      ])
    ], 544),
    _createVNode(_component_Dialog, {
      visible: _ctx.termsModal,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.termsModal) = $event)),
      style: { width: '50rem' },
      breakpoints: { '600px': '85vw' },
      modal: true,
      header: " ",
      class: "hide_cloe",
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TermsAndConditions)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}